import { ERROR } from "dropzone";

export default {
  DEPOSITS: "Consignes",
  DEPOSIT: "Consigne",
  APP_NAME: "Gestionnaire Cafétéria",
  EMAIL: "Courriel",
  PASSWORD: "Mot de passe",
  SIGN_IN: "Connexion",
  FORGOT_PASSWORD: "Mot de passe oublié ?",
  PAGE_NOT_FOUND: "La page demandée n'a pas été trouvée",
  RETURN_HOME: "Retour à l'accueil",
  WELCOME: "Bienvenue",
  MY_PROFILE: "Mon profil",
  LOGOUT: "Déconnexion",
  DASHBOARD: "Tableau de bord",
  USERS: "Utilisateurs",
  ROLES: "Rôles",
  ORGANIZATIONS: "Organisations",
  ORGANIZATION: "Organisation",
  PRODUCTS: "Produits",
  PRODUCT: "Produit",
  ALL: "Tout",
  NAME: "Nom",
  ADDRESS: "Adresse",
  PHONE: "Téléphone",
  CREATED_AT: "Créé le",
  SEARCH: "Recherche",
  NO_RESULTS: "Aucun résultat",
  PER_PAGE: "Par page",
  PAGINATION: "Pagination",
  VIEW: "Voir",
  EDIT: "Modifier",
  DELETE: "Supprimer",
  ACTIONS: "Actions",
  READ: "Lu",
  DISPLAY_FROM_X_TO_X_OF_X_ENTRIES:
    "Affichage de {from} à {to} sur {of} entrées",
  X_LINES_SELECTED: "{count} lignes sélectionnées",
  RETURN_TO_LIST: "Retour à la liste",
  SELECT_IMAGE: "Choisir une image",
  CHANGE_IMAGE: "Changer l'image",
  REMOVE_IMAGE: "Supprimer l'image",
  ROLE: "Rôle",
  FIRSTNAME: "Prénom",
  LASTNAME: "Nom",
  CONFIRM_PASSWORD: "Confirmer le mot de passe",
  RESELLERS: "Revendeurs",
  RESELLER: "Revendeur",
  LOCALE: "Langue",
  LOCALE_FR: "Français",
  LOCALE_EN: "Anglais",
  GLOBAL: "Global",
  NONE: "Aucun",
  UPDATED_AT: "Mis à jour le",
  PERMISSIONS: "Permissions",
  ALL_ORGANIZATIONS: "Toutes les organisations",
  ALL_RESELLERS: "Tous les revendeurs",
  ALL_ROLES: "Tous les rôles",
  ALL_USERS: "Tous les utilisateurs",
  ALL_CUSTOMERS: "Tous les clients",
  ALL_RECIPIENTS: "Tous les destinataires",
  ALL_CONTACTS: "Tous les contacts",
  ALL_CASH_REGISTERS: "Toutes les caisses",
  ALL_PRODUCTS: "Tous les produits",
  ALL_CATEGORY_EQUIPMENTS: "Toutes les catégories d'équipement",
  EXCERPT: "Description",
  OWNER: "Propriétaire",
  USER: "Utilisateur",
  YES: "Oui",
  NO: "Non",
  OK: "OK",
  INFO: "Info",
  WARNING: "Avertissement",
  PICTURE: "Photo",
  GALLERY: "Galerie",
  PRICE: "Prix",
  RATE: "Taux (%)",
  CODE: "Code",
  DEFAULT_TAXES: "Taxes par défaut",
  ALL_TAXES: "Toutes les taxes",
  INVOICES: "Factures",
  INVOICE: "Facture",
  RECIPIENT: "Destinataire",
  COUNTRY: "Pays",
  COUNTRIES: "Pays",
  STATES: "Régions",
  STATE: "Région",
  CITY: "Ville",
  ZIPCODE: "Code postal",
  NOTE: "Note",
  STATUS: "Statut",
  NO_STATUS: "Aucun statut",
  ALL_STATUSES: "Tous les statuts",
  CLIENT_VALIDATION_STATUS: "Statut de validation client",
  AMOUNT: "Montant",
  REFERENCE_DATE: "Date de référence",
  DAYS_LATE: "Jours de retard",
  PURCHASES_LATE_WIDGET_TITLE: "Commandes d’achats en attente de confirmation de réception",
  PURCHASES_LATE_WIDGET_EMPTY: "Toutes les commandes d'achat sont à jour.",
  SALES_LATE_WIDGET_TITLE: "Soumissions en attente de validation client",
  SALES_LATE_WIDGET_EMPTY: "Toutes les Soumissions sont validées par les clients.",
  PAIED: "Payé",
  TOTAL: "Total",
  TOTAL_PAIED: "Total payé",
  SOURCE: "Source",
  BASE: "Base",
  RATE: "Taux",
  RENT_PART: "Part de loyer",
  CREATED_BY: "Créé par",
  DETAILS: "Détails",
  PAYMENTS: "Paiements",
  UNIT_PRICE: "Prix unitaire",
  SUBTOTAL: "Sous-total",
  QUANTITY: "Quantité",
  DISCOUNT: "Réduction",
  REMAINING_PAYMENT_AMOUNT: "Balance",
  DISCOUNT_PERCENT: "Réduction (%)",
  CLOSE: "Fermer",
  CUSTOMER: "Client",
  CUSTOMERS: "Clients",
  LOGS: "Journaux",
  CAUSER: "Auteur",
  DATE: "Date",
  GO_BACK: "Retour",
  PACKAGE: "Forfait",
  PACKAGES: "Forfaits",
  ALL_PACKAGES: "Tous les forfaits",
  ALL_TYPES: "Tous les types",
  SUBSCRIPTION: "Inscription",
  SUBSCRIPTIONS: "Inscriptions",
  TYPE: "Type",
  TAX_TYPE_PERCENTAGE: "Pourcentage",
  TAX_TYPE_AMOUNT: "Montant",
  PAYMENT: "Paiement",
  ALL_INVOICES: "Toutes les factures",
  DISCOUNTS: "Réductions",
  DISCARD_CHANGES_AND_LEAVE_PAGE: "Abandonner les modifications et quitter ?",
  COMPANY_NAME: "Nom de l'entreprise",
  BILLING_ENTITY_TYPE_INDIVIDUAL: "Particulier",
  BILLING_ENTITY_TYPE_COMPANY: "Entreprise",
  CONTACTS: "Contacts",
  CONTACT: "Contact",
  SUPPLIER: "Fournisseur",
  SCHOOL: "École",
  TITLE: "Titre",
  TITLES: "Titres",
  ALL_TITLES: "Tous les titres",
  TITLE_MR: "Monsieur",
  TITLE_MDM: "Madame",
  TAG: "Étiquette",
  TAGS: "Étiquettes",
  ADD_TAG: "Ajouter une étiquette",
  BIRTHDAY: "Date d'anniversaire",
  SUPPLIERS: "Fournisseurs",
  FISCAL_NUMBER: "Numéro fiscal",
  UPDATE: "Modifier",
  UPDATED: "Modifié",
  COLOR: "Couleur",
  LINK_CONTACT: "Lier le contact",
  ADD_CONTACT: "Ajouter un contact",
  ADD: "Ajouter",
  SOURCE: "Source",
  LOCATIONS: "Emplacements",
  LOCATION: "Emplacement",
  ALL_LOCATIONS: "Tous les emplacements",
  FILES: "Fichiers",
  TRAININGS: "Formations",
  TRAINING: "Formation",
  FILE: "Fichier",
  ALL_FILES: "Tous les fichiers",
  FOLDERS: "Dossiers",
  FOLDER: "Dossier",
  ALL_FOLDERS: "Tous les dossiers",
  FILES_EXPLORER: "Explorateur",
  CAFETERIAS: "Cafétérias",
  CAFETERIA: "Cafétéria",
  ALL_CAFETERIAS: "Toutes les cafétérias",
  CUSTOMER_NUMBER: "Numéro client",
  ESTABLISHMENTS: "Établissements",
  ESTABLISHMENT: "Établissement",
  ALL_ESTABLISHMENT: "Tous les établissements",
  SERVICECENTERS: "Centres de service",
  SERVICECENTER: "Centre de service",
  ALL_SERVICECENTER: "Tous les centres de service",
  WAREHOUSE: "Entrepôt",
  WAREHOUSES: "Entrepôts",
  PURCHASES_ORDER: "Commande achat",
  PURCHASES_ORDERS: "Commandes achat",
  ISSUER: "Émetteur",
  PURCHASES_INVOICE: "Facture achat",
  PURCHASES_INVOICES: "Factures achat",
  PURCHASES_DELIVERY: "Livraison achat",
  PURCHASES_DELIVERIES: "Livraisons achat",
  PURCHASES_PAYMENT: "Paiement achat",
  PURCHASES_PAYMENTS: "Paiements achat",
  SALES_ORDER: "Soumission",
  SALES_ORDERS: "Soumissions",
  SALES_ORDERS_STANDARD: "Soumissions - Standard",
  SALES_ORDERS_SUBSIDIZED: "Soumissions - Aide alimentaire",
  SALES_ORDERS_CATERER: "Soumissions - Traiteur",
  SALES_INVOICE: "Facture vente",
  SALES_INVOICES: "Factures vente",
  SALES_DELIVERY: "Livraison vente",
  SALES_DELIVERIES: "Livraisons vente",
  SALES_PAYMENT: "Paiement vente",
  RESEND_CODE: "Renvoyez le code",
  ENABLE_2FA:
    "Souhaitez-vous activer la vérification en deux étapes pour sécuriser davantage votre compte ?",
  DISABLE_2FA:
    "Souhaitez-vous désactiver la vérification en deux étapes et revenir à la connexion sans 2FA ?",
  VERIFICATION_CODE: "Code de vérification",
  SUCCESS_VERIFICATION: "Vérification réussie",
  ERROR_VERIFICATION: "Échec de la vérification",
  REMEMBER_ME: "Se souvenir de moi pendant 12 heures",
  SALES_PAYMENTS: "Paiements vente",
  BILLING_INFORMATIONS: "Information de facturation",
  BILLING_ADDRESS: "Adresse de facturation",
  RESELLER_PRODUCTS: "Produits revendeur",
  RESELLER_SERVICES: "Services revendeur",
  RESELLER_INVOICES: "Factures revendeur",
  RESELLER_INVOICE: "Facture revendeur",
  RESELLER_ORDER: "Commande revendeur",
  RESELLER_PAYMENTS: "Paiements revendeur",
  SERVICES: "Services",
  SERVICE: "Service",
  RESELLER_PRODUCT: "Produit revendeur",
  RESELLER_SERVICE: "Service revendeur",
  ADD_USER: "Ajouter un utilisateur",
  ALLOWED_USERS: "Utilisateurs autorisés",
  APP: "Applications",
  DELIVERY_ADDRESS: "Adresse de livraison",
  OTHER_PHONES: "Autres téléphones",
  EXTENSION: "Extension",
  ALL_SUPPLIERS: "Tous les fournisseurs",
  PHONE_TYPE_MOBILE: "Mobile",
  PHONE_TYPE_HOME: "Domicile",
  PHONE_TYPE_OFFICE: "Bureau",
  PHONE_TYPE_BUSINESS: "Professionnel",
  PHONE_TYPE_FAX: "Fax",
  PHONE_TYPE_PAGER: "Bipeur",
  PHONE_TYPE_OTHER: "Autre",
  SELLING_TAXES: "Taxes de vente",
  BUYING_TAXES: "Taxes d'achat",
  SELLING_PRICE: "Prix de vente",
  SALES_PRICING: "Prix de ventes",
  CUSTOM_PRICE: "Prix personnalisé",
  SUBSIDIZED_PRICE: "Prix aide alimentaire",
  CATERER_PRICE: "Prix traiteur",
  BUYING_PRICE: "Prix coûtant",
  DESTINATION_WAREHOUSE: "Entrepôt de destination",
  SOURCE_WAREHOUSE: "Entrepôt source",
  STOCK_MOVEMENT: "Mouvement de stock",
  STOCK_MOVEMENTS: "Mouvements de stock",
  HAS_WAREHOUSE: "Dispose d'un entrepôt",
  SAVE: "Enregistrer",
  SAVED: "Enregistré",
  SAVE_AND_LEAVE: "Enregistrer et quitter",
  LEAVE_WITHOUT_SAVING: "Quitter sans enregistrer",
  UNSAVED_CHANGES_WARNING:
    "Vous avez des modifications non enregistrées. Voulez-vous quitter ?",
  EXPECTED_QUANTITY: "Quantité attendue",
  DELIVERED_QUANTITY: "Quantité livrée",
  HAS_FOLDER: "Dispose d’un dossier dans l’explorateur de fichiers",
  IMPORTS: "Imports",
  IMPORT: "Import",
  NEXT_STEP: "Étape suivante",
  PREV_STEP: "Étape précédente",
  CANCEL: "Annuler",
  DOWNLOAD: "Télécharger",
  DOWNLOADING: "Téléchargement en cours",
  DOWNLOAD_FAILED: "Échec du téléchargement",
  DOWNLOAD_CSV_FILE: "Télécharger le fichier csv",
  RETURN_TO_LOGIN: "Retour à la connexion",
  RESET_PASSWORD_SENT:
    "Un e-mail contenant un lien de réinitialisation du mot de passe a été envoyé.",
  RESET_PASSWORD_USER_NOT_FOUND:
    "Nous ne trouvons pas d'utilisateur avec cette adresse e-mail.",
  SEND_PASSWORD_RESET_LINK:
    "Envoyer le lien de réinitialisation du mot de passe",
  RESET_PASSWORD: "Réinitialiser le mot de passe",
  PASSWORD_UPDATED: "Mot de passe mis à jour",
  TOKEN_ERROR:
    "Token de changement de mot de passe invalide, merci de réessayer",
  EMAIL_ERROR: "Courriel invalide, merci de réessayer",
  SUPPLY_RULES: "Règles d'approvisionnement",
  SUPPLY_RULE: "Règle d'approvisionnement",
  SEE_MORE: "Voir plus",
  FOLD_WIDGET: "Replier",
  UNFOLD_WIDGET: "Déplier",
  CATEGORY: "Catégorie",
  UPCOMING_PURCHASE: "Achat à venir",
  COPY: "Copier",
  ADD_CAFETERIA: "Ajouter une cafétéria",
  ESTABLISHMENTS_DIRECTORY: "Bottin établissements",
  PROFESSION: "Profession",
  WAREHOUSES_CONFIGURED: "Entrepôts associés",
  APPLY_CONFIGURATION: "Appliquer les configurations",
  SYNCHRONIZATIONS: "Synchronisations",
  NEW: "Nouveau",
  UN_SELECT_ALL: "Décocher tout",
  SELECT_ALL: "Cocher tout",
  VALIDATE: "Valider",
  ADD_PRODUCTS: "Ajouter des produits",
  PRINT: "Pdf",
  CATEGORIES: "Catégories",
  TAX: "Taxe",
  TAXES: "Taxes",
  TAX_GROUP: "Groupe de taxes",
  TAX_GROUPS: "Groupes de taxes",
  ORDER_ITEM_TAX_GROUPS: "Taxes applicables des lignes",
  SEND: "Envoyer",
  MAIL_TO: "À",
  MAIL_FROM: "Expéditeur",
  MAIL_BODY: "Message",
  MAIL_SEND_ME_COPY: "Envoyez-moi une copie",
  MAIL_CC: "Cc",
  MAIL_BCC: "Cci",
  MAIL_SUBJECT: "Objet",
  MAIL_TYPE_EMAIL_ENTER: "Tapez un e-mail et appuyez sur Entrée",
  SELECT_CONTACTS: "Entrez plusieurs contacts",
  EMAIL_SENT_SUCCESSFULLY: "Courriel envoyé avec succès",
  OPTIONS: "Paramètres",
  DEFAULT_TAX_GROUPS: "Groupe de taxes par défaut",
  UNIT_OF_MEASURE: "Unité de mesure",
  UNIT_OF_MEASURES: "Unités de mesure",
  ALL_UNIT_OF_MEASURES: "Toutes les unités de mesure",
  EMAIL_INFOS_SUBJECT_INVOICE: "Facture  {seq_number} de {organization}",
  EMAIL_INFOS_SUBJECT_ORDER: "Soumission  {seq_number} de {organization}",
  EMAIL_INFOS_SUBJECT_PURCHASES_ORDER: "Nouvelle commande {client_id} {establisment_name}",
  EMAIL_INFOS_SUBJECT_INTERNAL_ORDER: "Commande interne {seq_number} de {organization}",
  EMAIL_INFOS_SUBJECT_EQUIPMENT_TRANSFER:
    "Transfert d'équipement {seq_number} de {organization}",
  EMAIL_INFOS_SUBJECT_PAYMENT: "Paiement  {seq_number} de {organization}",
  EMAIL_INFOS_SUBJECT_DELIVERY: "Livraison  {seq_number} de {organization}",
  START_TYPING_CITY_REGION_COUNTRY:
    "Commencez par saisir la ville, la région ou le pays pour compléter l'adresse",
  EMAIL_INFOS_BODY: `
    <strong>Bonjour {username},</strong><br>
    Nous vous remercions pour votre confiance. Voici les détails de votre soumission. 
    N’hésitez surtout pas à communiquer avec nous si vous avez des questions.
    <p> Bonne journée ! </p>
    <p> <br> </p>
    <p>{sender_name}</p>
    <p>{email}</p>
    <p>{phone}</p>
    <p>{organization}</p>
  `,
  SALES_ORDER_EMAIL_INFOS_BODY: `
    <strong>Bonjour cher client,</strong><br>
    Nous vous remercions pour votre confiance. Voici les détails de votre soumission. 
    N’hésitez surtout pas à communiquer avec nous si vous avez des questions.
    <p>Bonne journée !</p>
    {link}
    <p> <br> </p>
    <p>{sender_name}</p>
    <p>{email}</p>
    <p>{phone}</p>
    <p>{organization}</p>
  `,
  PURCHASES_ORDER_EMAIL_INFOS_BODY: `
    <strong>Bonjour {supplier_name},</strong><br>
    Voici une nouvelle commande. Veuillez confirmer la réception ainsi que le jour de livraison.
    <p> Merci et bonne journée ! </p>
    <p><br></p>
    <p>{sender_name}</p>
    <p>{email}</p>
    <p>{phone}</p>
    <p>{organization}</p>
  `,
  INTERNAL_ORDER_EMAIL_INFOS_BODY: `
    <strong>Bonjour {username},</strong><br>
    Voici la commande interne de {satellite} pour la semaine du {week_starts_at} au {week_ends_at}.
    Vous la trouverez en pièce jointe. Merci de la confirmer dans l'application.
    <p> Merci et bonne journée ! </p>
    {link}
    <p><br></p>
    <p>{sender_name}</p>
    <p>{email}</p>
    <p>{phone}</p>
    <p>{organization}</p>
  `,
  EQUIPMENT_TRANSFER_EMAIL_INFOS_BODY: `
    <strong>Bonjour {username},</strong><br>
    Voici une demande de transfert d'équipement ({transfer_type}) de {source} vers votre établissement,
    prévue le {transfer_date}. Vous la trouverez en pièce jointe.
    Merci de l'accepter ou de la refuser dans l'application.
    <p> Merci et bonne journée ! </p>
    {link}
    <p> <br> </p>
    <p>{sender_name}</p>
    <p>{email}</p>
    <p>{phone}</p>
    <p>{organization}</p>
  `,
  EMAIL_INFOS_SUBJECT_INVOICE: "Facture  {seq_number} de Les services alimentaires Laniel St-Laurent inc.",
  SALES_INVOICE_EMAIL_INFOS_BODY: `
    <p>Bonjour cher client,</p>
    <p>&nbsp;</p>
    <p>Merci de nous avoir choisis pour votre événement !</p>
    <p>Nous espérons sincèrement que tout était à votre goût.</p>
    <p>&nbsp;</p>
    <p>Si vous avez deux petites minutes, nous vous invitons à balayer le code QR ci-dessous pour répondre à notre court sondage de satisfaction. Votre avis nous est précieux et nous aide à toujours nous améliorer.</p>
    <p>&nbsp;</p>
    <p>Vous trouverez également la facture en pièce jointe.</p>
    <p>&nbsp;</p>
    <p>Au plaisir de vous servir à nouveau !</p>
    <p>&nbsp;</p>
    <p>Cordialement,</p>
    <p>&nbsp;</p>
    <p>
      Sondage de satisfaction : 
      <a href="https://forms.office.com/Pages/ResponsePage.aspx?id=DQSIkWdsW0yxEjajBLZtrQAAAAAAAAAAAANAASrf0UFUQjVOQ08xNVJSMk03TERBMUQ3UVM1UEZDMC4u">
        <img src="https://api.lanielstlaurent.ca/storage/products/0/picture/N5kybaAtGRT7wor4N9jsgl7Ovpy9x6NJTy9x0dNu.png" alt="QR Code Sondage de satisfaction" width="200" height="200" />
      </a>
    </p>
  `,
  MANAGER: "Gestionnaire",
  TOTAL_VALUE: "Valeur totale",
  SUMMARY: "Résumé",
  COUNTRY_CODE: "Code pays",
  SELECT_COUNTRY: "Choisir un pays",
  PHONE_NUMBER: "Numéro de téléphone",
  QUEBEC: "Québec",
  RECEIVER_BY: "Réceptionné par",
  COUNTRY_CODE: "Code pays",
  SELECT_COUNTRY: "Choisir un pays",
  PHONE_NUMBER: "Numéro de téléphone",
  UNIT_OF_MEASURE_UNIT: "Unité",
  UNIT: "Unité",
  TERMS_CONDITIONS: "Termes et conditions",
  ITEMS_DISCOUNTS: "Réduction produits",
  DESCRIPTION: "Description",
  NUMBER: "Numéro",
  DELETE: "Supprimer",
  EXPORT_EXCEL: "Exporter en excel",
  EXPORT_EQUIPMENT_EXCEL: "Exporter les équipements en excel",
  CORRECT_STOCK_FROM_QUANTITY: "Prise d’inventaire à partir de la quantité en stock",
  CORRECT_STOCK: "Prise d’inventaire",
  HAS_TAXES: "Taxée",
  PAYMENT_TERMS: "Termes de paiement",
  PAYMENT_TERM: "Terme de paiement",
  ALL_PAYMENT_TERMS: "Tous les termes de paiement",
  ADRESSED_TO: "Adressée à",
  EXPIRY_DATE: "Date d'échéance",
  POSITION: "Intitulé du poste",
  WAREHOUSE_QUANTITY: "Quantité en stock",
  AJUSTED_QUANTITY: "Quantité ajustée",
  VALIDATE_SALES_ORDER: "Veuillez cliquer ici pour consulter et accepter la soumission",
  VALIDATE_INTERNAL_ORDER: "Veuillez cliquer ici pour consulter et confirmer la commande interne",
  FORMAT: "Format",
  ORDER_DUBE: "Commande Dubé",
  ORDER_MEGABURO: "Commande MégaBuro",
  ORDER_PEPSICO: "Pepsico",
  EVENTS: "Évènements",
  EVENT: "Évènement",
  TODAY: "Aujourd'hui",
  PREV: "Précédent",
  NEXT: "Suivant",
  WEEK: "Semaine",
  MONTH: "Mois",
  DAY: "Jour",
  CASH_REGISTER: "Caisse",
  CASH_REGISTER_READING: "Lectures de Caisse",
  CASH_REGISTER_READING_ITEM: "Vente",
  CASH_REGISTERS: "Caisses",
  CASH_REGISTER_READINGS: "Lectures de Caisse",
  CASH_REGISTER_READING_ITEMS: "Ventes",
  CASH_REGISTER_READING_EXPENSE_ITEMS: "Dépenses",
  CASH_REGISTER_READING_PAYMENT_ITEMS: "Paiements",
  CASH_REGISTER_READING_EXPENSE_ITEM: "Dépense",
  ALL_CATEGORIES: "Toutes les catégories",
  PAYMENT_METHOD: "Moyen de paiement",
  REPORTS: "Rapports",
  BILL_VALUE: "Valeur du Billet",
  BILL_COUNT: "Nombre de Billet",
  CATEGORY_EQUIPMENTS: "Catégorie d'équipement",
  EQUIPMENTS: "Équipements",
  BRAND: "Marque",
  SERIAL_NUMBER: "Numéro de série",
  GUARANTEE: "Garantie",
  BELONG_TO_LANIEL: "Appartient à Laniel",
  EQUIPMENT_STATUS_ARCHIVED: "Archivé",
  EQUIPMENT_STATUS_AVAILABLE: "Disponible",
  EQUIPMENT_STATUS_UNAVAILABLE: "Non disponible",
  WEEKLY_REPORTS: "Rapports hebdomadaires",
  MODEL: "Modèle",
  PURCHASE_YEAR: "Date d'achat",
  SERVICE_PLAN: "Plan de service",
  FORMAT: "Format",
  SOFTWARE: "Logiciel",
  LOAN_YEAR: "Date de prêt",
  DISPLAY_ZERO_LINES: "Afficher les lignes à zéro",
  BELONG_TO_LANIEL_OR_NOT: "Appartient à Laniel ou non",
  DO_NOT_BELONG_TO_LANIEL: "N'appartient pas à Laniel",
  POSITION: "Fonction et département ",
  REPORT_FILE: "Fichier de rapport",
  ERROR: "Erreur",
  INVALID_QUANTITY: "Quantité invalide",
  MOVEMENT_DATE: "Date du mouvement",
  ESTABLISHMENTS_WIDGET_TITLE: "Inventaire et rapport hebdomadaire",
  INVOICE_NUMBER: "# Facture",
  REPORTING_NAME: "Catégorie de rapport",
  COPIED_TO_CLIPBOARD: "Copié dans le presse-papiers",
  COPY_FAILED_MANUAL: "La copie automatique a échoué. Vous pouvez copier manuellement le texte ci-dessous.",
  MANUAL_COPY_IF_NEEDED: "Copie manuelle si nécessaire",
  CONTINUE: "Continuer",
  BULK_SET: "Définir en masse",
  RESET: "Réinitialiser",
  SEARCH_PLACEHOLDER: "Rechercher...",
  ACTION_CANNOT_BE_UNDONE: "Cette action ne peut pas être annulée",
  DATES_PLACEHOLDER: "Dates",
  DISCOUNTED_SUBTOTAL: "Sous-total après réduction",
  SELECT_OPTION: "Sélectionner une option",
  TOTAL_WITH_TAXES: "Total (avec taxes)",
  WITH_TAXES: "avec taxes",
  TRANSFERS: "Transferts",
  TRANSFERS_INCOMING: "Transferts entrants",
  TRANSFERS_OUTGOING: "Transferts sortants",
  INTERNAL_INVOICE: "Facture interne",
  INTERNAL_INVOICES: "Factures internes",
  INTERNAL_INVOICES_INCOMING: "Facturation interne entrante",
  INTERNAL_INVOICES_OUTGOING: "Facturation interne sortante",
  ESTABLISHMENT_TRANSFERS: "Transferts d'établissement",
  ESTABLISHMENT_TRANSFER: "Transfert d'établissement",
  EQUIPMENT_TRANSFERS: "Transferts d'équipement",
  ESTABLISHMENT_TRANSFERS_INCOMING: "Transferts entrants",
  ESTABLISHMENT_TRANSFERS_OUTGOING: "Transferts sortants",
  ESTABLISHMENT_INTERNAL_INVOICES_INCOMING: "Factures internes entrantes",
  ESTABLISHMENT_INTERNAL_INVOICES_OUTGOING: "Factures internes sortantes",
  LOADING: "Chargement...",
  DESTINATION : "Destination",
  SOURCE : "Source",
  SUBMIT: "Soumettre",
  NO_DATA: "Pas de données",
  TO_VALIDATE: "À valider",
  VIEW_ALL: "Voir tout",
  ESTABLISHMENT_INTERNAL_INVOICES: "Factures internes",
  ESTABLISHMENT_INTERNAL_ORDERS: "Commandes internes",
  EXPECTED_DELIVERY_DATE: "Date de livraison prévue",
  VALIDATED_AT: "Validée le",
  WRITE_YOUR_COMMENT: "Écrivez votre commentaire",
  NAME_ON_CARD: "Nom sur la carte",
  CARD_NUMBER: "Numéro de carte",
  CCV: "CCV",
  SAVE_NEW_CARD: "Enregistrer la nouvelle carte",
  SELECT_A_COLUMN: "Sélectionner une colonne",
  PROJECT: "Projet",
  BUDGET: "Budget",
  USERS_LABEL: "Utilisateurs",
  PAGE_VISITS: "Visites de page",
  VISITORS: "Visiteurs",
  UNIQUE_USERS: "Utilisateurs uniques",
  BOUNCE_RATE: "Taux de rebond",
  SOCIAL_TRAFFIC: "Trafic social",
  REFERRAL: "Référence",
  SEE_ALL: "Voir tout",
  LIGHT_TABLE: "Tableau léger",
  COMPLETION: "Achèvement",
  ALTERNATIVE: "Alternative",
  DASHBOARDS: "Tableaux de bord",
  FILTERS: "Filtres",
  ACTION: "Action",
  ANOTHER_ACTION: "Autre action",
  SOMETHING_ELSE_HERE: "Autre chose ici",
  SEE_DETAILS: "Voir les détails",
  TASKS_COMPLETED: "Tâches terminées",
  ITEMS_SOLD: "Articles vendus",
  NOTIFICATIONS: "Notifications",
  OVERVIEW: "Aperçu",
  SALES_VALUE: "Valeur des ventes",
  SALES: "Ventes",
  PERFORMANCE: "Performance",
  TOTAL_ORDERS: "Total des commandes",
  PROGRESS_TRACK: "Suivi de progression",
  PROJECTS_PROGRESS: "{completed}/{total} projets",
  ACTIVITY_FEED: "Fil d'actualité",
  FOLLOW: "Suivre",
  DAYS_AGO: "il y a {count} jours",
  AND_MORE: "et {count} de plus",
  IMAGE_PLACEHOLDER: "Image de remplacement",
  ACTIVITY_FEED_SAMPLE_TEXT:
    "Les profils personnels sont le moyen idéal pour capter l'attention et convaincre les recruteurs de continuer à lire votre CV, car vous expliquez d'emblée pourquoi ils devraient vous embaucher.",
  SAMPLE_USER_JOHN_SNOW: "John Snow",
  SAMPLE_USER_JESSICA_ROWLAND: "Jessica Rowland",
  SAMPLE_USER_AUDREY_LOVE: "Audrey Love",
  SAMPLE_USER_MICHAEL_LEWIS: "Michael Lewis",
  SAMPLE_USER_JESSICA_STONES: "Jessica Stones",
  SAMPLE_USER_JOHN_MICHAEL: "John Michael",
  SAMPLE_USER_ALEX_SMITH: "Alex Smith",
  SAMPLE_USER_SAMANTHA_IVY: "Samantha Ivy",
  SAMPLE_USER_RYAN_TOMPSON: "Ryan Tompson",
  SAMPLE_USER_ROMINA_HADID: "Romina Hadid",
  SAMPLE_USER_ALEXANDER_SMITH: "Alexander Smith",
  SAMPLE_USER_JESSICA_DOE: "Jessica Doe",
  SAMPLE_COMMENT_1:
    "Cras sit amet nibh libero nulla vel metus scelerisque ante sollicitudin. Cras purus odio vestibulum in vulputate viverra turpis.",
  SAMPLE_COMMENT_2:
    "Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis.",
  USER_STATUS_ONLINE: "En ligne",
  USER_STATUS_IN_MEETING: "En réunion",
  USER_STATUS_OFFLINE: "Hors ligne",
  PROJECT_STATUS_PENDING: "En attente",
  PROJECT_STATUS_COMPLETED: "Terminé",
  PROJECT_STATUS_DELAYED: "En retard",
  PROJECT_STATUS_ON_SCHEDULE: "Dans les temps",
  TASK_CALL_WITH_DAVE: "Appel avec Dave",
  TASK_LUNCH_MEETING: "Déjeuner d'affaires",
  TASK_ARGON_DASHBOARD_LAUNCH: "Lancement du tableau de bord Argon",
  TASK_WINTER_HACKATON: "Hackathon d'hiver",
  TIME_10_30: "10 h 30",
  PROJECT_ARGON_DESIGN_SYSTEM: "Argon Design System",
  PROJECT_ANGULAR_NOW_UI_KIT_PRO: "Angular Now UI Kit PRO",
  PROJECT_BLACK_DASHBOARD: "Black Dashboard",
  PROJECT_REACT_MATERIAL_DASHBOARD: "React Material Dashboard",
  PROJECT_VUE_PAPER_UI_KIT_PRO: "Vue Paper UI Kit PRO",
  MONTH_MAY_SHORT: "Mai",
  MONTH_JUN_SHORT: "Juin",
  MONTH_JUL_SHORT: "Juil",
  MONTH_AUG_SHORT: "Août",
  MONTH_SEP_SHORT: "Sept",
  MONTH_OCT_SHORT: "Oct",
  MONTH_NOV_SHORT: "Nov",
  MONTH_DEC_SHORT: "Déc",
  PRODUCTS_REPORT: "Rapport des produits",
  POS_PRODUCTS_REPORT: "Produits vendus (Caisses)",
  WEEKLY_REPORTS_REPORT: "Rapport hebdo",
  BY_WAREHOUSE: "Par entrepôt",
  DOCUMENT_TYPES: "Types de documents",
  PRODUCT_SEARCH: "Rechercher un produit",
  APPLY_FILTERS: "Appliquer les filtres",
  START_DATE: "Date de début",
  END_DATE: "Date de fin",
  SKU: "SKU",
  PURCHASES: "Achats",
  TOTAL_PRODUCTS: "Total produits",
  TOTAL_SALES: "Total ventes",
  TOTAL_PURCHASES: "Total achats",
  TOTAL_TRANSFERS_INCOMING: "Total transferts entrants",
  TOTAL_TRANSFERS_OUTGOING: "Total transferts sortants",
  TOTAL_INTERNAL_INVOICES_INCOMING: "Total facturation interne entrante",
  TOTAL_INTERNAL_INVOICES_OUTGOING: "Total facturation interne sortante",
  DATE_RANGE: "Période",
  DATES_PLACEHOLDER: "Sélectionner une période",
  UNITS: "unités",
  TOTALS: "Totaux",
  DAILY: "Quotidien",
  WEEKLY: "Hebdomadaire",
  MONTHLY: "Mensuel",
  TRANSACTIONS: "Transactions",
  TOTAL_AMOUNT: "Montant total",
  PAYMENT_TYPES: "Types de paiement",
  CASH: "Comptant",
  CARD: "Carte",
  PREPAID_CARD: "Carte prépayée",
  CASHIER: "Caissier",
  RECALCULATE: "Recalculer",
  RECALCULATE_SUCCESS: "Calculs mis a jour avec succes",

  // Texte affiché dans les cases de recherche : indique ce que la recherche consulte.
  SEARCH_HINT: {
    NUMBER_OR_ESTABLISHMENT: "Numéro ou établissement",
    CASH_REGISTER_READING: "Établissement, cafétéria ou caisse",
    PRODUCT_NAME: "Nom du produit",
    PRODUCT: "Produit : nom, code ou SKU",
    PRODUCT_WITH_SUPPLIER_CODE: "Produit : nom, code, SKU ou code fournisseur",
    PRODUCT_NAME_OR_SKU: "Produit : nom ou SKU",
    SUPPLIER_PRODUCT: "Produit, code fournisseur ou fournisseur",
    NAME: "Nom",
    NAME_OR_CODE: "Nom ou code",
    NAME_OR_DESCRIPTION: "Nom ou description",
    CODE_NAME_OR_DESCRIPTION: "Code, nom ou description",
    CONTACT: "Nom, entreprise, courriel ou téléphone",
    PERSON: "Nom, courriel ou téléphone",
    ESTABLISHMENT: "Nom, adresse, ville, courriel ou téléphone",
    ESTABLISHMENT_NAME: "Nom de l'établissement",
    SUPPLIER: "Nom, courriel, téléphone ou n° de taxe",
    SUPPLY_RULE: "Règle, entrepôt ou fournisseur",
    TAX: "Nom, libellé ou n° de taxe",
    OPTION: "Option ou valeur",
    LOG: "Type, description ou détails",
    FILE: "Nom, chemin ou description",
    FILE_OR_FOLDER: "Fichier ou dossier",
    DOCUMENT: "Numéro ou description",
    SALES_ORDER: "Numéro, évènement ou description",
    RESELLER_INVOICE: "Numéro, client ou description",
    STOCK_MOVEMENT: "Entrepôt d'origine ou de destination",
    CODE: "Code",
    ANY_COLUMN: "Texte dans n'importe quelle colonne",
  },
  // Option « tous » des filtres de liste : nomme le filtre au lieu d'« Aucun ».
  FILTER_ALL: {
    PRODUCTION_ESTABLISHMENTS: "Toutes les productions",
    SATELLITE_ESTABLISHMENTS: "Tous les satellites",
    SOURCES: "Toutes les sources",
    DESTINATIONS: "Toutes les destinations",
  },
};
